import { type ComponentProps } from 'react';

export const TeeIcon = (props: ComponentProps<'svg'>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0002 15.6903C15.2029 15.6903 17.7993 13.0939 17.7993 9.89123C17.7993 6.68849 15.2029 4.09216 12.0002 4.09216C8.7975 4.09216 6.20117 6.68849 6.20117 9.89123C6.20117 13.0939 8.7975 15.6903 12.0002 15.6903Z"
      stroke="currentColor"
      strokeWidth="1.13"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.78271 16.5809C9.04546 17.3768 10.5076 17.7991 12.0002 17.7991C13.4929 17.7991 14.955 17.3768 16.2177 16.5809"
      stroke="currentColor"
      strokeWidth="1.13"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17.7991V19.9078"
      stroke="currentColor"
      strokeWidth="1.13"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0546 11.7364C12.909 11.7364 12.791 11.6184 12.791 11.4728C12.791 11.3272 12.909 11.2092 13.0546 11.2092"
      stroke="currentColor"
      strokeWidth="1.13"
    />
    <path
      d="M13.0542 11.7364C13.1998 11.7364 13.3178 11.6184 13.3178 11.4728C13.3178 11.3272 13.1998 11.2092 13.0542 11.2092"
      stroke="currentColor"
      strokeWidth="1.13"
    />
    <path
      d="M11.9999 13.8452C11.8543 13.8452 11.7363 13.7272 11.7363 13.5816C11.7363 13.436 11.8543 13.318 11.9999 13.318"
      stroke="currentColor"
      strokeWidth="1.13"
    />
    <path
      d="M12 13.8452C12.1456 13.8452 12.2636 13.7272 12.2636 13.5816C12.2636 13.436 12.1456 13.318 12 13.318"
      stroke="currentColor"
      strokeWidth="1.13"
    />
    <path
      d="M14.6362 13.318C14.4906 13.318 14.3726 13.1999 14.3726 13.0544C14.3726 12.9088 14.4906 12.7908 14.6362 12.7908"
      stroke="currentColor"
      strokeWidth="1.13"
    />
    <path
      d="M14.6362 13.318C14.7818 13.318 14.8998 13.1999 14.8998 13.0544C14.8998 12.9088 14.7818 12.7908 14.6362 12.7908"
      stroke="currentColor"
      strokeWidth="1.13"
    />
    <path
      d="M15.6904 11.2093C15.5448 11.2093 15.4268 11.0912 15.4268 10.9457C15.4268 10.8001 15.5448 10.6821 15.6904 10.6821"
      stroke="currentColor"
      strokeWidth="1.13"
    />
    <path
      d="M15.6904 11.2093C15.836 11.2093 15.954 11.0912 15.954 10.9457C15.954 10.8001 15.836 10.6821 15.6904 10.6821"
      stroke="currentColor"
      strokeWidth="1.13"
    />
  </svg>
);
